export default function loadOnScroll($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    link(scope, elem, attrs) {
      const loadOnScrollFunc = scope.$eval(attrs.loadOnScroll);
      const scrollContainer = elem[0];

      elem.bind('scroll', () => {
        const isLoading = scope.$eval(attrs.isLoading);

        if (scrollContainer.scrollTop <= 0 && !isLoading) {
          const scrollHeight = scrollContainer.scrollHeight;

          loadOnScrollFunc(() => {
            $timeout(() => {
              scrollContainer.scrollTop =
                parseInt(scrollContainer.scrollHeight, 10) - parseInt(scrollHeight, 10);
            }, 0);
          });
        }
      });
    },
  };
}
